module.exports = {
      id: "newsletter-usage",
      viewBox: "0 0 26 23.012",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#newsletter",
      toString: function () {
        return this.url;
      }
    }